import { Label, Input } from '@/components/FormElements';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const EditorFormStackedBarsFields = _ref => {
  let {
    config,
    onChange
  } = _ref;
  const headings = config.headings || [];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Label, {
      text: "Headings",
      caption: "Left and right headings for results",
      className: parentStyles.formField,
      children: /*#__PURE__*/_jsxs("div", {
        className: parentStyles.formField__grid,
        children: [/*#__PURE__*/_jsx(Input, {
          placeholder: "Left results",
          defaultValue: headings[0] || '',
          onChange: evt => onChange('', {
            headings: [evt.target.value || '', headings[1]]
          })
        }), /*#__PURE__*/_jsx(Input, {
          placeholder: "Right results",
          defaultValue: headings[1] || '',
          onChange: evt => onChange('', {
            headings: [headings[0], evt.target.value || '']
          })
        })]
      })
    })
  });
};

export default EditorFormStackedBarsFields;